import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '@app/services/utils.service';

@Component({
    selector: 'page-redirect',
    template: '',
})
export class Redirect{
  utils = inject(UtilsService);
  //
  constructor(route:ActivatedRoute){
    const {snapshot:{data:{href}}} = route;
    console.info('redirectTo: ' + href);
    if(typeof href === 'string'){
      if( href.match(/^https?:\/\//) ){
        location.href = href;
      }else{
        const {snapshot:{queryParams}} = route;
        this.utils.navigate(href,{relativeTo:route,queryParams})
      }
    }
  }
}
